module.exports = __webpack_public_path__ + "static/media/level-up-circle.9fef5f49.png";